const SECTION_TYPES = {
  base: 'base',
  filled: 'filled',
};

export default SECTION_TYPES;